/* Revolv : lecture des courtes vidéos muettes en boucle (video[data-rv-loop]).
   Lecture seulement quand la vidéo est visible à l'écran et l'onglet affiché,
   jamais si le visiteur a demandé à réduire les animations (l'image fixe reste). */
(function () {
  if (window.rvLoopVideo) return;
  var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var io = null;
  var all = [];

  function reduced() { return !!(mq && mq.matches); }

  function play(v) {
    if (reduced() || document.visibilityState === 'hidden') return;
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }

  if ('IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        v.rvIn = e.isIntersecting;
        if (v.rvIn) { play(v); } else { v.pause(); }
      });
    }, { threshold: 0.2 });
  }

  function scan() {
    var found = document.querySelectorAll('video[data-rv-loop]');
    for (var i = 0; i < found.length; i++) {
      var v = found[i];
      if (v.rvObs) continue;
      v.rvObs = true;
      all.push(v);
      if (io) { io.observe(v); } else { v.rvIn = true; play(v); }
    }
  }

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState !== 'visible') return;
    all.forEach(function (v) { if (v.rvIn && v.isConnected) play(v); });
  });

  if (mq && mq.addEventListener) {
    mq.addEventListener('change', function () {
      all.forEach(function (v) {
        if (reduced()) { v.pause(); v.load(); } else if (v.rvIn) { play(v); }
      });
    });
  }

  document.addEventListener('shopify:section:load', scan);
  window.rvLoopVideo = { scan: scan };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
})();